// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'IOVF', 'IOVF Fallback'"},"className":"__className_55cf86","variable":"__variable_55cf86"};